export enum Status {
  Approved = 1,
  Pending = 2,
  Expired = 3,
  Rejected = 4
}

export namespace Status {

  export function values() {
    return Object.keys(Status).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/constants/Enums.ts